// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(callback/*, thisArg*/) {
    var T, k;
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);
    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;
    // 4. If isCallable(callback) is false, throw a TypeError exception. 
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }
    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }
    // 6. Let k be 0
    k = 0;
    // 7. Repeat, while k < len
    while (k < len) {
      var kValue;
      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];
        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

if (!window.forEach) {
    // Reference: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
    window.forEach = function (Collections, callback, thisArg) {
        var T = thisArg || this || window;
        if (Collections == null) {
            throw new TypeError("Collections is null or not defined");
        }
        if (typeof callback !== "function") {
            throw new TypeError(callback + " is not a function");
        }
        for (var i = 0; i < Collections.length; i++) {
            if (i in Collections) {
                var Element = Collections[i];
                callback.call(T, Element, i, Collections);
            }
        }
    };
}

window.addEventListener = window.addEventListener || window.attachEvent;
window.removeEventListener = window.removeEventListener || window.detachEvent;

/*\
|*|  :: XMLHttpRequest.prototype.sendAsBinary() Polyfill ::
|*|  https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#sendAsBinary()
\*/
if (!XMLHttpRequest.prototype.sendAsBinary) {
    XMLHttpRequest.prototype.sendAsBinary = function (sData) {
        var nBytes = sData.length, ui8Data = new Uint8Array(nBytes);
        for (var nIdx = 0; nIdx < nBytes; nIdx++) {
            ui8Data[nIdx] = sData.charCodeAt(nIdx) & 0xff;
        }
        /* send as ArrayBufferView...: */
        this.send(ui8Data);
        /* ...or as ArrayBuffer (legacy)...: this.send(ui8Data.buffer); */
    };
}

if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

if (!Date.now) {
    Date.now = function() {
        return new Date().getTime();
    };
}

/* 
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-/animating
 * requestAnimationFrame polyfill by Erik M�ller. fixes from Paul Irish and Tino Zijdel
 * MIT license
*/
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] 
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }
 
    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var frameTime = 1000 / 60;
            var timeToCall = Math.max(0, frameTime - Math.abs(currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
 
    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());
var timestamp = 0;
var rAF = window.requestAnimationFrame
       || function(fn) {
            var timenow = +new Date();
            var fps = 1000 / 60;
            var timer = Math.max(0, fps - (timenow - timestamp));
            var animation = setTimeout(fn, timer);
            timestamp = timenow + timer;
            return animation;
};
var cAF = window.cancelAnimationFrame;


// Source: https://developer.mozilla.org/en-US/docs/Web/Events/wheel
// creates a global "addWheelListener" method
// example: addWheelListener( elem, function( e ) 
// { console.log( e.deltaY ); e.preventDefault(); } );
(function(window,document) {

    var prefix = "", _addEventListener, support;

    // detect event model
    if ( window.addEventListener ) {
        _addEventListener = "addEventListener";
    } else {
        _addEventListener = "attachEvent";
        prefix = "on";
    }

    // detect available wheel event
    support = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
              document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
              "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox

    window.addWheelListener = function( elem, callback, useCapture ) {
        _addWheelListener( elem, support, callback, useCapture );

        // handle MozMousePixelScroll in older Firefox
        if( support == "DOMMouseScroll" ) {
            _addWheelListener( elem, "MozMousePixelScroll", callback, useCapture );
        }
    };

    function _addWheelListener( elem, eventName, callback, useCapture ) {
        elem[ _addEventListener ]( prefix + eventName, support == "wheel" ? callback : function( originalEvent ) {
            !originalEvent && ( originalEvent = window.event );

            // create a normalized event object
            var event = {
                // keep a ref to the original event object
                originalEvent: originalEvent,
                target: originalEvent.target || originalEvent.srcElement,
                type: "wheel",
                deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
                deltaX: 0,
                deltaZ: 0,
                preventDefault: function() {
                    originalEvent.preventDefault ?
                        originalEvent.preventDefault() :
                        originalEvent.returnValue = false;
                }
            };
            
            // calculate deltaY (and deltaX) according to the event
            if ( support == "mousewheel" ) {
                event.deltaY = - 1/40 * originalEvent.wheelDelta;
                // Webkit also support wheelDeltaX
                originalEvent.wheelDeltaX && ( event.deltaX = - 1/40 * originalEvent.wheelDeltaX );
            } else {
                event.deltaY = originalEvent.detail;
            }

            // it's time to fire the callback
            return callback( event );

        }, useCapture || false );
    }

})(window,document);

if (!String.prototype.substringBefore) {
    String.prototype.substringBefore = function(searchValue, repeat) {
        var re = repeat || 1;
        var str = this.toString();
        for (var i = 0; i < re; i++) {
            str = str.substring(0, str.indexOf(searchValue));
        }
        return str;
    };
}
if (!String.prototype.substringAfter) {
    String.prototype.substringAfter = function(searchValue, repeat) {
        var re = repeat || 1;
        var str = this.toString();
        for (var i = 0; i < re; i++) {
            str = str.substring(str.indexOf(searchValue) + 1);
        }
        return str;
    };
}

/*END* Polyfill global objects and functions */

/*START* Dynamic functions */

function cbTransform(arg){
    return {
        "-webkit-transform": arg,
        "-moz-transform": arg,
        "-ms-transform":arg,
        "transform": arg
    };
}
function domCbTransform(el, arg) {
    if (el) {
        var css = cbTransform(arg);
        for (var p in css) {
            el.style[p] = css[p];
        }
    }
}
function cbTransition(arg){
    return {
        "-webkit-transition": arg,
        "transition": arg
    };
}

function searchWord(str, word) {
    var re = new RegExp("\\b" + word + "\(\\s|$)");
    return str ? str.search(re) : -1;
}
function hasClass(el, cls) {
    if (el && cls.trim() !== "") return searchWord(el.className, cls) !== -1;
}
function addClass(el, cls) {
    if (el && cls) {
        var eCls = el.className;
        var re = new RegExp("\\b" + cls + "\(\\s|$)");
        if (!eCls.match(re)) el.className = (eCls + " " + cls).trim();
    }
}
function addClassAll(co, cls) {
    if (co && cls) {
        forEach(co, function(el) {
            addClass(el, cls);
        });
    }
}
function removeClass(el, cls) {
    if (el && cls) {
        var eCls = el.className;
        var re = new RegExp("\\b" + cls + "\(\\s|$)");
        if (eCls.match(re)) el.className = eCls.replace(re, "").trim();
    }
}
function removeClassAll(co, cls) {
    if (co && cls) {
        forEach(co, function(el) {
            removeClass(el, cls);
        });
    }
}
function replaceClass(el, oldCls, newCls) {
    if (el) {
        var eCls = el.className;
        var str = newCls ? " " + newCls : "";
        if (eCls === "" || !oldCls) {
            el.className = (eCls + str).trim();
        } else {
            var re = new RegExp("\\b" + oldCls + "\(\\s|$)");
            el.className = eCls.replace(re, str).trim();
        }
    }
}
function replaceClassAll(co, oldCls, newCls) {
    forEach(co, function(el) {
        replaceClass(el, oldCls, newCls);
    });
}
function switchClassName(el, ca, cb) {
    if (el) {
        var cls = el.className;
        if (searchWord(cls, ca) > -1) replaceClass(el, ca, cb);
        else if (searchWord(cls, cb) > -1) replaceClass(el, cb, ca);
    }
}
function switchClass(a, b) {
    var ac = a.className;
    a.className = b.className;
    b.className = ac;
}
function getAncestor(child, name) {
    var parent = child.parentElement;
    var rename = new RegExp("\\b" + name + "\(\\s|$)");
    if (!parent || parent.nodeName === "#document") {
        return null;
    }
    if (rename.test(parent.className)) {
        return parent;
    } else {
        return getAncestor(parent, name);
    }
}
function getForm(el) {
    var ctn = el.parentElement;
    return ctn.tagName === "FORM" ? ctn : getForm(ctn);
}
function getElementByName(o, name) {
    return o.querySelector("[name='" + name + "']");
}
function getIndex(el, q) {
    if (el) {
        if (jQuery && el instanceof jQuery) {
            return el.parent().children(q).index(el);
        } else {
            var pe = el.parentElement;
            var a = !q ? pe.children : pe.querySelectorAll(q);
            for (var i = 0, j = 0; i < a.length; i++) {
                if (pe === a[i].parentElement) {
                    if (el === a[i]) return j;
                    j++;
                }
            }
            return -1;
        }
    } else {
        return -1;
    }
}
function removeArrayItem(array, item, all) {
    if (Array.isArray(array) && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            if (item === array[i]) {
                array.splice(i, 1);
                if (all) i--; else break;
            }
        }
    }
}
function getDataSet(el) {
    var map = {};
    if (!el.dataset) {
        var as = el.attributes;
        var tuc = function(x) { return x.substr(1).toUpperCase(); };
        for (var i = 0; i < as.length; i++) {
            var a = as[i];
            var n = a.name;
            var m = n.match(/^data-(.+)/);
            if (m) map[m[1].replace(/-([a-z])/ig, tuc)] = a.value;
        }
    } else {
        map = el.dataset;
    }
    return map;
}
function setDataSet(el, key, val) {
    if (!el.dataset) {
        var tlc = function(x) { return "-" + x.toLowerCase(); };
        var att = "data-" + key.replace(/[A-Z]/g, tlc);
        el.setAttribute(att, val);
    } else {
        el.dataset[key] = val;
    }
}
function switchElementsById(id1, id2) {
    document.getElementById(id1).style.display = "none";
    document.getElementById(id2).style.display = "";
}
function switchElementsByClassName(cls1, cls2) {
    document.getElementsByClassName(cls1)[0].style.display = "none";
    document.getElementsByClassName(cls2)[0].style.display = "";
}
function setInputValue(sel, targ) {
    var a = typeof sel === "string" ? sel : sel.value;
    document.querySelector(targ).value = a;
}
function changeValue(el, x, y, id) {
    document.getElementById(id).value = el.checked ? x : y;
}
function resetCheckbox(name) {
    var boxes = document.getElementsByName(name);
    for(var i = 0; i<boxes.length; i++) {
        if(boxes[i].checked) boxes[i].checked = false;
    }
}
function decodeEntities(str) {
    var ta = document.createElement("textarea");
    ta.innerHTML = str;
    return ta.value;
}
function decodeElements(els) {
    var str = "";
    if(els.length) {
        for(var i = 0; i < els.length; i++) {
            str = decodeEntities(els[i].innerHTML);
            els[i].innerHTML = str;
        }
    } else {
        str = decodeEntities(els.innerHTML);
        els.innerHTML = str;
    }
}
function replaceURL(q, x, state) {
    var qs = location.search.replace("?", ""),
        qa = qs.split("&"),
        url = location.pathname + "?";

    if (qs === "") {
        qs = q + "=" + x;
        url += qs;
    } else {
        if (qs.indexOf(q + "=") === -1) {
            qa.push(q + "=" + x);
        } else {
            for (var i = 0; i < qa.length; i++) {
                if (qa[i].indexOf(q + "=") === 0) {
                    qa[i] = q + "=" + x;
                    break;
                }
            }
        }
        url += qa.join("&");
    }
    history.replaceState("", (state) ? state : q + " " + x, url);
}
function getQuery(param) {
    var qs = location.search.replace("?", "");
    if (!param || param === "") return qs;
    if (qs === "") return null;
    
    var qa = qs.split("&");
    for (var i = 0; i < qa.length; i++) {
        var q = qa[i];
        if (q.indexOf("=") > -1) {
            var a= q.split("=");
            if (a[0] === param) return a[1];
        } else {
            if (q === param) return "";
        }
    }
}
function scrollToEl(q, toTop) {
    var pos = $(q).offset().top,
        elH = $(q).height();
        
    if (elH < winH && !toTop) pos -= (winH - elH) / 2;
    $("html, body").animate({scrollTop: pos});
}

function qs(q, ctn) {
    if (typeof q !== "string") {
        return q;
    }
    if (ctn) {
        return ctn.querySelector(q);
    } else {
        return document.querySelector(q);
    }
}
function qsa(q, ctn) {
    if (typeof q !== "string") {
        return q;
    }
    if (ctn) {
        return ctn.querySelectorAll(q);
    } else {
        return document.querySelectorAll(q);
    }
}

function bindEvent(q, type, handler, callback) {
    forEach(qsa(q), function(el) {
        el.addEventListener(type, handler);
        if (callback) callback.call(el);
    });
}

function newXHR() {
    var xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        try {
            xhr = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
            try {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {
                return null;
            }
        }
    }
    return xhr;
}
function siteAjax(url, callback, returnVar, blackout, method) {
    var xhr = newXHR();
    if (!xhr) return;
    if (blackout) ajaxBlackout(true);
    var noCache = "cache=" + Math.random();
    var nonCacheUrl = url + (url.indexOf("?") > -1 ? "&" : "?") + noCache;
    xhr.open(method ? method : "GET", nonCacheUrl, true);
    xhr.onreadystatechange = function() {
        if (this.readyState == 4) {
            if (this.status == 200) {
                if (callback) {
                    var res = this.responseText;
                    callback(res, returnVar);
                }
            } else {
                console.error(this.statusText);
                popErrorSite('errorMessageAjaxSite');
                document.getElementById('errorMessageAjaxSite').innerHTML = 
                    "Error " + this.status + "! Sending request failed.";
            }
            if (blackout) ajaxBlackout(false);
        }
    };
    xhr.send(null);
}

function formatDecimal(n, d) {
    if (isNaN(n) || (n - Math.floor(n)).length - 2 <= d) {
        return n;
    }
    var r = Math.pow(10, isNaN(d) ? 2 : d);
    return Math.round(n * r) / r;
}
function formatMoney($, round) {
    var lang = document.documentElement.lang,
        dec = round ? 0 : 2,
        x = parseFloat(isNaN($) ? $.replace(",", ".") : $),
        res = x.toFixed(dec).toString();

    return (lang === "en") ? "$" + res : res.replace(".", ",") + "$";
}
function formatZeros(n, l) {
    var str = n.toString();
    var nl = str.length;
    l = l || 2;
    while (nl < l) {
        str = "0" + str;
        nl++;
    }
    return str;
}

function getLocalDateTime(date) {
    var d2 = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return d2.toISOString().replace("T", " ").substring(0, 19);
}
function getLocalDate(date) {
    var d2 = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return d2.toISOString().substring(0, 10);
}
function getLocalTime(date) {
    return date.toTimeString().substring(0, 9);
}
function parseMonthSystem(str) {
    var list = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    if (lang === "fr") {
        list = ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"];
    }
    return list.indexOf(str.toLowerCase());
}
function getMonthName(i, l) {
    var name = {"en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "fr": ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"]};
    return name[l ? l : lang][i];
}
function getDayName(i, l) {
    var name = {"en": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], "fr": ["dimanche", "lundi", "mardi", "mecredi", "jeudi", "vendredi", "samedi", "dimanche"]};
    return name[l ? l : lang][i];
}
function nextDate(d, n, raw) {
    try {
        if (n === undefined) n = 1;
        var _ = new Date(d);
        var _d = _.getTime() + (n * 24 * 60 * 60 * 1000);
        _.setTime(_d);
        return raw ? _ : _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" 
                + formatZeros(_.getDate());
    } catch (ex) {
        console.log(ex);
        return null;
    }
}
function nextHour(dt, n) {
    try {
        if (n === undefined) n = 1;
        var _ = new Date(dt);
        _.setHours(_.getHours() + n);
        return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" 
                + formatZeros(_.getDate()) + " " + _.toTimeString();
    } catch (ex) {
        console.log(ex);
        return null;
    }
}

function randomHex() {
    return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
}
function randomIdNumber() {
    return Math.floor((1 + Math.random()) * 10000).toString().substring(1);
}
function randomIdLetter(size) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var chars = "";
    var _size = size === undefined || size < 1 ? 5 : size;
    for (var i = 0; i < _size; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}
function randomNumber(min, max) {
    var _min = min === undefined ? 0 : min;
    var _max = max === undefined ? 10000000000000000 : max;
    return Math.round((Math.random() * (_max - _min)) + _min);
}

function getElementOffset(el, parent) {
    var top  = 0;
    var left = 0;
    
    for (; el.offsetParent; el = el.offsetParent) {
        if (parent && el === parent) break;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
    
    return {top: top, left: left};
}

function foc(inp) {
    if (inp.value && inp.value !== "") {
        addClass(inp, "filled");
    } else {
        removeClass(inp, "filled");
    }
    setTimeout(function() {foc(inp);}, 160);
}

function chkReqFields(f) {
    var $form = typeof f === "string" ? $("#"+f) : $(f),
        chk = true,
        chkbox = true,
        aNumber = true;
    
    $form.find(".required").each(function() {
        var $inp = $(this),
            type = $inp.attr("type"),
            val = $inp.val();
        
        switch (type) {
            case "radio":
            case "checkbox":
                if($inp.prop("checked")) {
                    $inp.removeClass("alert-o");
                    chkbox = true;
                    return false;
                } else {
                    $inp.addClass("alert-o");
                    chkbox = false;
                }
                break;
                
            default: if ($inp.hasClass("inp-num") === false) {
                $inp.val(val.trim());
                val = val.replace(/\s/g, "");
                if(val === "" || val.length === 0 || type === "email" && !val.match(/\w@\w/)) {
                    toggleClassInputError(this);
                    $inp.blur(chkAlertField);
                    chk = false;
                } else {
                    toggleClassInputError(this, true);
                }
                break;
            }
            
            case "number":
                var x = parseInt(val),
                    minX = $inp.attr("min") && x < $inp.attr("min");

                if (isNaN(x) || minX || /\D/.test(x)) {
                    toggleClassInputError(this);
                    $inp.blur(chkDigitField);
                    aNumber = false;
                } else {
                    toggleClassInputError(this, true);
                }
                break;
        }
    });
    $form.find(".errmsg-emptyfields").css("display" , chk ? "none" : "block");
    $form.find(".errmsg-agree").css("display" , chkbox ? "none" : "block");
    
    return chk && chkbox && aNumber;
}
function chkDigitField(e) {
    var $field = $(e.currentTarget || e.target || e.srcElement),
        val = parseInt($field.val());
    
    if(!(isNaN(val) && /\D/.test(val))) {
        toggleClassInputError($field[0], true);
        $field.off(e.type);
    }
}
function chkAlertField(e) {
    var $field = $(e.currentTarget || e.target || e.srcElement),
        val = $field.val().replace(/\s/g, "");
    
    if(val !== "" && val.length !== 0) {
        toggleClassInputError($field[0], true);
        $field.off(e.type);
    }
}
function chkForm(id) {
    if(chkReqFields(id)) {
        ajaxBlackout(true);
        document.getElementById(id).submit();
    }
}
function chkFormO(form) {
    if (chkReqFields(form)) {
        ajaxBlackout(true);
        form.submit();
    }
}
function chkPhoneNumber(value) {
    var re = /^(((\+?[0-9]{1,3} )?\([0-9]{3}\) [0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\-])?[0-9]{3}\-[0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\.])?[0-9]{3}\.[0-9]{3}\.[0-9]{4})|\+?[0-9 ]{10,20})( ?(x|ext|extension)[\. ]?\d{1,6})?$/;
    return re.test(value);
}
function sanitizePhone(value) {
    var raw = value.substring(0).replace(/[\+\(\)\.\- ]/g, "");
    try {
        var ext = raw.search(/(extension|ext|x)/);
        if (ext > -1) raw = raw.substring(0, ext);
        var group = [raw.substr(-7, 3), raw.substr(-4)];
        if (raw.length > 7) group.unshift(raw.substr(-10, 3));
        if (raw.length > 10) group.unshift(raw.substr(0, raw.length - 10));
        return (value.match(/\+/) ? "+" : "") + group.join("-");
    } catch (ex) {
        return raw;
    }
}
function chkNameField(value) {
    var re = /^(?:[a-z\u00C0-\u024F]+['\.\- ]?[a-z\u00C0-\u024F]?)+$/i;
    return re.test(value);
}
function sanitizeName(value) {
    var aa = value.split(" ");
    for (var i = 0; i < aa.length; i++) {
        var ab = aa[i].split("-");
        for (var j = 0; j < ab.length; j++) {
            var ac = ab[j].split(".");
            for (var k = 0; k < ac.length; k++) {
                var ad = ac[k];
                ac[k] = ad.substr(0, 1).toUpperCase() + ad.substr(1).toLowerCase();
            }
            ab[j] = ac.join(".");
        }
        aa[i] = ab.join("-");
    }
    return aa.join(" ");
}
function canadaPC(code) {
    var filter = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
    return filter.test(code);
}

function l10n(fr, en) {
    return lang === "fr" ? fr : en;
}

/*END* Dynamic functions */